module.exports = __webpack_public_path__ + "img/bcc071.857a3c74.jpeg";